var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-15 1 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.022 7.17 1.514-1.513L0 2.12l-1.513 1.513zm-.707.707L-2.22 4.342l-9.89 9.89-.716 4.25 4.25-.714zM-.354 1.061a.5.5 0 0 1 .708 0l4.242 4.242a.5.5 0 0 1 0 .707L-7.98 18.588a.5.5 0 0 1-.27.14l-5.101.857a.5.5 0 0 1-.576-.576l.857-5.1a.5.5 0 0 1 .14-.27z"
  })));
};
export default SvgPen;